
export class TranslationKey {
    public TranslationKeyId:string;

    public Name:string;

    public Description:string;

    public TranslationCategoryId:number;

    public EnglishTranslatedValue:string;

    constructor(TranslationKeyId:string = "", Name:string = ""){
        this.TranslationKeyId = TranslationKeyId;
        this.Name = Name;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/translation-key.ts